export default __webpack_public_path__ + "roboto-v27-latin-700italic.c756cf083283e3aed4201f0d90e29d6e.woff2";